import React, { useEffect, useState } from "react";
import "../../Styles/DeactivateUsers.css";
import Loader from "../../Components/Loader";

function HostelService() {
    const [admins, setAdmins] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredAdmins, setFilteredAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedAdmins, setSelectedAdmins] = useState({});
    const [editingAdmin, setEditingAdmin] = useState(null);
    const [saveLoading, setSaveLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem("authToken");
                if (!token) {
                    console.error("No authentication token found");
                    return;
                }
                setLoading(true);

                // Fetch admins data
                const adminsResponse = await fetch(
                    "https://api.uniums.com/api/User/active-admins",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const adminsData = await adminsResponse.json();

                // Fetch hostel access data
                const hostelAccessResponse = await fetch(
                    "https://api.uniums.com/api/User/hostel-access",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const hostelAccessData = await hostelAccessResponse.json();

                if (adminsResponse.ok && hostelAccessData.success) {
                    const adminsArray = adminsData.admins;
                    const hostelAccessArray = hostelAccessData.data;

                    setAdmins(adminsArray);
                    setFilteredAdmins(adminsArray);

                    // Map hostel access status to admin IDs
                    const accessMap = {};
                    adminsArray.forEach(admin => {
                        // Find if this admin has hostel access
                        const accessRecord = hostelAccessArray.find(
                            record => record.adminId === admin._id
                        );
                        accessMap[admin._id] = accessRecord ? accessRecord.hostelAccess : false;
                    });

                    setSelectedAdmins(accessMap);
                } else {
                    console.error("Failed to fetch data");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = admins.filter(
            (admin) =>
                admin.name.toLowerCase().includes(value) ||
                admin.email.toLowerCase().includes(value) ||
                admin.organizationName.toLowerCase().includes(value) ||
                admin.organizationAddress.toLowerCase().includes(value) ||
                admin.organizationContact.toLowerCase().includes(value)
        );
        setFilteredAdmins(filtered);
    };

    const handleCheckboxChange = (adminId) => {
        setSelectedAdmins(prev => ({
            ...prev,
            [adminId]: !prev[adminId]
        }));
    };

    const handleAddHostel = (adminId) => {
        setEditingAdmin(adminId);
    };

    const handleSave = async (adminId) => {
        try {
            setSaveLoading(true);
            const token = localStorage.getItem("authToken");
            if (!token) {
                console.error("No authentication token found");
                return;
            }

            const response = await fetch("https://api.uniums.com/api/User/add-hostel-access", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    adminId,
                    hostelAccess: selectedAdmins[adminId]
                })
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Hostel access updated successfully:", data.message);
                // You could add a success notification here
            } else {
                console.error("Failed to update hostel access:", data.message);
                // You could add an error notification here
            }
        } catch (error) {
            console.error("Error saving hostel access:", error);
        } finally {
            setSaveLoading(false);
            setEditingAdmin(null);
        }
    };

    const handleCancel = () => {
        setEditingAdmin(null);
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div className="DeactivateUsers_container hostel_service">
            <h1>Hostel Service</h1>
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Search by Name, Email, or Organization"
                    value={searchTerm}
                    onChange={handleSearch}
                    className="search-box"
                />
            </div>

            <div className="admin-table-container">
                <table className="DeactivateUsers_table">
                    <thead>
                        <tr>
                            <th>SL No</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Organization Name</th>
                            <th>Organization Address</th>
                            <th>Contact</th>
                            <th>Status</th>
                            <th>Add Hostel</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredAdmins.map((admin, index) => (
                            <tr key={admin._id}>
                                <td>{index + 1}</td>
                                <td>{admin.name}</td>
                                <td>{admin.email}</td>
                                <td>{admin.organizationName}</td>
                                <td>{admin.organizationAddress}</td>
                                <td>{admin.organizationContact}</td>
                                <td className="active_td">
                                    {admin.active ? "Active" : "Inactive"}
                                </td>
                                <td className="checkbox_td_center">
                                    <input
                                        type="checkbox"
                                        checked={selectedAdmins[admin._id] || false}
                                        onChange={() => handleCheckboxChange(admin._id)}
                                        disabled={editingAdmin !== admin._id && editingAdmin !== null}
                                    />
                                </td>
                                <td>
                                    {editingAdmin === admin._id ? (
                                        <div className="action-buttons">
                                            <button
                                                className="save-button"
                                                onClick={() => handleSave(admin._id)}
                                                disabled={saveLoading}
                                            >
                                                {saveLoading ? "Saving..." : "Save"}
                                            </button>
                                            <button
                                                className="cancel-button"
                                                onClick={handleCancel}
                                                disabled={saveLoading}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            className="action-button"
                                            onClick={() => handleAddHostel(admin._id)}
                                            disabled={editingAdmin !== null}
                                        >
                                            {selectedAdmins[admin._id] ? "Edit Hostel" : "Add Hostel"}
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default HostelService;